$('.sectionQuestionPymes .rower h3').click(function () {
    $('.sectionQuestionPymes .rower h3').removeClass('h3_active');
    $(this).addClass('h3_active');
    $('.sectionQuestionPymes .rower h4').removeClass('active');
    $('.sectionQuestionPymes .rower .h4_'+this.id).addClass('active');
});
